export const PATH_TO_DOWNLOAD = '../../../server/uploads/';

export function replaceSpacesWithUnderscore(inputString: string): string {
    return inputString.includes(' ') ? inputString.replace(/ /g, '_') : inputString;
}

export const FEATURE_FLAGS: any = {
    // Add all the feature flags here
    IMAGE_UPLOAD: true    // before making it true, make sure to add image(text) coulmn in style table in db
}

export async function getImageBase64(imagePath: string) {
    // Check if the incoming imagePath is already in base64 format
    if (imagePath.startsWith('data:image/')) {
        // If it's already base64, just return it
        return imagePath;
    }

    // Otherwise, treat imagePath as a URL and fetch it to convert to base64
    try {
        const response = await fetch(imagePath); // Fetch the image as a Blob
        const blob = await response.blob();

        // Convert Blob to base64 string
        const reader = new FileReader();

        return new Promise((resolve, reject) => {
            reader.onloadend = () => {
                resolve(reader.result as string);  // Return the base64 string
            };
            reader.onerror = (error) => {
                reject(error);
            };
            reader.readAsDataURL(blob);  // Read the blob as a base64 string
        });
    } catch (error) {
        console.error('Error fetching image:', error);
        return '';
    }
}

export function getStoreInfo(column: string, value: string, storeList: any[]) {
    // find the store in the storeList based on the column and value
    if (!storeList || !column || !value) return null;

    const store = storeList.find((store) => store[column] === value);
    if (store) {
        return store;
    }
    // console.log('Store not found for column:', column, 'and value:', value);
    return storeList.find((store) => store.location === 'DC-Caledonia') || null;
}

export const VENDORS = [
    {
        company: 'G2000',
        name: 'G2000 EXPRESS INC',
        address: '1130 CALEDONIA ROAD,',
        city: 'NORTH YORK, ON. M6A 2W5'
    }
]

// export const IMAGE_PATH = `http://192.168.0.135:3000/public/styleImages/`;Add commentMore actions

export function getCorporateNo(shipper: any, receiver: any): string {
    const priorityLocations = ['SVP-Kingston', 'Barrie'];

    // Check priority locations in order
    for (const location of priorityLocations) {
        if (shipper?.location === location) return shipper.corporate_no;
        if (receiver?.location === location) return receiver.corporate_no;
    }
    // Default fallback
    return '2138398 ONTARIO INC.';
}

export enum ZONES {
    SOUTH = 'SOUTH',
    WEST = 'WEST',
    DOCK = 'DOCK',
    AURORA_NORTH = 'AURORA_NORTH',
    AURORA_WEST = 'AURORA_WEST',
    KIRBY = 'KIRBY',
    AURORA_EAST = 'AURORA_EAST',
    AURORA_FRONT = 'AURORA_FRONT',
    RICHMOND = 'RICHMOND',
}

export const ZONE_OPTIONS = Object.values(ZONES).map((zone) => ({
    label: zone,
    value: zone,
}));

export const LOCATION_ZONES: Record<string, ZONES[]> = {
    DCCAL: [ZONES.SOUTH, ZONES.DOCK, ZONES.WEST],
    AURORA: [ZONES.AURORA_WEST, ZONES.AURORA_NORTH, ZONES.AURORA_FRONT],
};
